import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Menu from "src/components/common/Menu";
import { MenuContext } from "src/context/MenuContext";
import { CopyContext } from "src/context/CopyContext";
import Header from "src/components/common/Header";
import { useForm } from "react-hook-form";
import ProjectCostValidataionSchema from "src/validation/ProjectCostValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { ValidationMessages } from 'src/components/common/ValidationMessage';
import ScrollTop from 'src/components/common/ScrollTop';
import DoughnutChart from "src/components/common/DoughnutChart";
import { useDispatch, useSelector } from "react-redux";
import { addProjectCost } from "src/store/projectcost";
import { getSingleProjects, resetSingleProject } from "src/store/project";
import { getProjectMemberData } from "src/store/projectstaff";
import { getMcode } from "src/store/mcode";
import { getUsers } from "src/store/user";
import { th } from "date-fns/locale";

const ProjectDetails = () => {

    const { id } = useParams();
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [validationMessages, setValidationMessages] = useState([])
    const [value, setValue] = useState([]);
    const [selectedType, setSelectedType] = useState('1');
    const [filteredData, setFilteredData] = useState([]);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const projectData = useSelector((state) => state.project.singleData);
    const authRole = useSelector((state) => state.mcode.data.role);
    const memberData = useSelector((state) => state.projectstaff.projectMemberData);
    const user = useSelector((state) => state.user.data);

    const [costValue, setCostValue] = useState(projectData?.total_cost || 0);
    const totalMinutes = Array.isArray(memberData) ? memberData.reduce((sum, member) => sum + (parseInt(member.total_work_minute) || 0), 0) : 0;
    const totalUnitPrice = Array.isArray(memberData) ? memberData.reduce((sum, member) => sum + (parseFloat(member.unit_price) || 0), 0) : 0;

    const calculateMonthlyTotal = () => {
        if (!memberData || !Array.isArray(memberData)) return { hours: 0, minutes: 0 };

        const totalMinutes = memberData.reduce((sum, member) => {
            return sum + parseInt(member.monthly_work_minute || 0);
        }, 0);

        return {
            hours: Math.floor(totalMinutes / 60),
            minutes: totalMinutes % 60
        };
    };


    useEffect(() => {
        if (projectData?.total_cost) {
            setCostValue(projectData.total_cost);
        }
    }, [projectData.total_cost]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(ProjectCostValidataionSchema),
        mode: 'onSubmit',
    });

    useEffect(() => {
        const messagesArray = Object.values(errors).map((error) => error.message);
        setValidationMessages(messagesArray);
    }, [errors]);

    useEffect(() => {
        dispatch(getSingleProjects(id));
        dispatch(getProjectMemberData(id));
        dispatch(getMcode({ section_cd: 'projectcategory,role' }));
        dispatch(getUsers());
    }, []);

    useEffect(() => {
        if (id) {
            setValue("id", id);
        }
    }, [id, setValue]);

    useEffect(() => {
        if (!memberData) return;

        const now = new Date();

        if (selectedType === "1") {
            // Show all data
            setFilteredData(memberData);
        }
    }, [selectedType, memberData]);



    const handlePopupOpen = () => {
        reset();
        setPopupVisible(true); // Show the pop-up
    };

    const handlePopupClose = () => {
        setPopupVisible(false); // Hide the pop-up
    };

    const clickProjectListBtn = () => {
        dispatch(resetSingleProject());
        navigate("/projectList");
    };
    const { setCopyFlg } = useContext(CopyContext);
    const { order_date, billing_date, billing_plans_date, start_date, end_date, ...filteredProjectData } = projectData;
    const clickCopyBtn = () => {
        setCopyFlg(true);
        alert("You are going to duplicate the previous project. Are you sure?");
        navigate("/projectInput", { state: { formData: filteredProjectData } });
    };

    const onSubmit = (data) => {
        if (data) {
            dispatch(addProjectCost(data))
                .then((response) => {
                    if (response.payload.errors) {
                        setValidationMessages(response.payload.errors?.cost_price)
                    }
                    else {
                        alert('The cost registration has been completed.')
                        handlePopupClose();
                        reset();
                        dispatch(getSingleProjects(id));
                    }
                })
                .catch((error) => {
                    setValidationMessages(error);
                });
        }
    }

    const { visibleMenu } = useContext(MenuContext);

    return (
        <>
            <div className="project_detail">
                {visibleMenu && <Menu />}
                <div className={visibleMenu ? "menu-open" : "menu-closed"}>
                    <div className="navbar navbar-fixed-top navbar-absolute">
                        <Header sx={{ mb: 4 }} />
                    </div>
                    <section className="container-fluid contents-top">
                        <div className="menu-closed" style={{ paddingTop: "0px" }}>
                            <div className="text-right">
                                <button type="button" className="btn btn-default" onClick={clickProjectListBtn}>
                                    <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>Back to List
                                </button>
                            </div>
                            <div className="project_detail_wrap" style={{ width: "90%", margin: "0 auto" }}>
                                <h3 className="title-style01">Project Details</h3>
                                <div className="row">
                                    <div className="col-md-5">
                                        <p>Quick Network</p>
                                        <p className="lead"> {projectData.name} &nbsp;
                                            <a href={`/projectEdit/${id}`} className="btn btn-default">
                                                <span className="glyphicon glyphicon-pencil" aria-hidden="true" />
                                            </a>
                                            &nbsp;
                                            <button id="pj_copy_btn" className="btn btn-success" onClick={clickCopyBtn}>Copy</button>
                                        </p>
                                        <p>Period：　{projectData.start_date} ～ {projectData.end_date}</p>
                                        <p>
                                            Claim：　{" "}
                                            {projectData.billing_date ? projectData.billing_date : ''} <span className="label label-success">Completed</span>
                                        </p>
                                        <p>Completion report：</p>
                                    </div>
                                    <div className="col-md-3">
                                        <DoughnutChart orderPrize={projectData.order_price} costPrize={costValue} fontColor={"#000000"} />
                                    </div>
                                    <div className="col-md-3">
                                        <p className="lead text-right common-alignment">
                                            Order amount: <span>Rs {projectData.order_price}</span>
                                        </p>
                                        <p className="lead text-right common-alignment">
                                            Cost price: <span className="project_cost_price">{'Rs ' + costValue}</span>
                                        </p>
                                        <p className="lead text-right common-alignment">
                                            Gross profit: <span>{costValue ? projectData.order_price - costValue : 'Rs 0'}</span>
                                        </p>
                                    </div>

                                    <div className="col-md-1">
                                        <p className="mb30">　</p>
                                        <p>
                                            <button type="button" className="btn btn-green ml5 clr-green-weak jq-popup-open jq-popup-cost_register btn_cost_detail" onClick={handlePopupOpen}>
                                                <span className="glyphicon glyphicon-plus" aria-hidden="true" />
                                            </button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <div className={isPopupVisible ? "popup-area jq-popup" : ''}>
                {isPopupVisible && (
                    <div className="layout-popup">
                        <div className="popup-close jq-popup-close">
                            <span className="glyphicon glyphicon-remove" aria-hidden="true" onClick={handlePopupClose} />
                        </div>
                        <div className="title-area">Fixed cost registration</div>
                        <form id="cost_register_form" onSubmit={handleSubmit(onSubmit)}>
                            <input type="hidden" {...register("t_project_id")} defaultValue={id} />
                            {validationMessages && validationMessages.length > 0 && (
                                <div style={{ background: "#ffe4e2" }}>
                                    <ValidationMessages
                                        messages={validationMessages}
                                        onClose={() => setValidationMessages([])}
                                    />
                                </div>
                            )}
                            <div className="form-area">
                                <p>
                                    Cost name <span style={{ color: "red" }}>*</span>
                                </p>
                                <input type="text" className="form-control" {...register("cost_name")} />
                            </div>
                            <div className="form-area">
                                <p>
                                    Cost (price) [excluding tax]{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </p>
                                <input type="number" className="form-control" {...register("cost_price")} />
                            </div>
                            <div className="form-area">
                                <p>Remarks</p>
                                <textarea {...register("remarks")} className="form-control" rows={3} style={{ minHeight: 150, width: 650 }} />
                            </div>
                            <div className="btn-area">
                                <button type="submit" className="btn btn-success btn-block jq-regist_cost_price" >Registrer</button>
                                <button type="button" className="btn btn-default btn-block jq-delete_cost_price" hidden style={{ display: "none" }}>Delete</button>
                            </div>
                        </form>
                    </div>
                )}
            </div>
            <div className="col-md-6 text-right">
                <label className="radio-inline" htmlFor="inlineCheckbox1" >
                    <input type="radio" id="inlineCheckbox1" name="detail_type" value="1" defaultChecked onChange={() => setSelectedType('1')} /> Member
                </label>

                <label className="radio-inline" htmlFor="inlineCheckbox2">
                    <input type="radio" id="inlineCheckbox2" name="detail_type" value="2" onChange={() => setSelectedType('2')} /> Current Month
                </label>
            </div>
            <table className="project-staf-table">
                <thead>
                    <tr style={{ alignItems: "center" }}>

                        {selectedType === "2" ? (
                            <>
                                <th className="project-staff-thead">
                                    <i className="fas fa-calendar-alt"></i> Month
                                </th>
                                <th className="project-staff-thead">
                                    <i className="fas fa-calendar-alt"></i> Working Hours
                                </th>
                                <th className="project-staff-thead">
                                    <i className="fas fa-dollar-sign"></i> Unit Price
                                </th>
                                <th className="project-staff-thead">
                                    <i className="fas fa-percentage"></i> Percentage
                                </th>
                            </>
                        ) : (
                            <>
                                <th className="project-staff-thead">
                                    <i className="fas fa-user-tie"></i> Project Staff
                                </th>
                                <th className="project-staff-thead">
                                    <i className="fas fa-user-shield"></i> Role
                                </th>
                                <th className="project-staff-thead">
                                    <i className="fas fa-user-clock"></i> Working Hours
                                </th>
                                <th className="project-staff-thead">
                                    <i className="fas fa-dollar-sign"></i> Unit Price
                                </th>
                            </>
                        )}
                    </tr>
                </thead>

                <tbody>
                    {filteredData && filteredData.length > 0 ? (
                        filteredData.map((memberdata, index) => (
                            <tr key={index} className="project-staff-row">

                                {selectedType === "2" ? (
                                    <>
                                        <td className="project-staff-data">
                                            May
                                        </td>
                                        <td className="project-staff-data">
                                            {memberdata.monthly_work_minute ? (
                                                (() => {

                                                    const hours = Math.floor(memberdata.monthly_work_minute / 60);

                                                    const minutes = memberdata.monthly_work_minute % 60;
                                                    return (
                                                        <span className="confirm_style">
                                                            {hours}H {minutes}M
                                                        </span>
                                                    );
                                                })()
                                            ) : (
                                                <span className="confirm_style">N/A</span>
                                            )}
                                        </td>
                                        <td className="project-staff-data">
                                            {memberdata.unit_price ? (
                                                <span className="confirm_style">{memberdata.unit_price} Rs</span>
                                            ) : (
                                                <span className="confirm_style">N/A</span>
                                            )}
                                        </td>
                                        <td className="project-staff-data">
                                            {memberdata.percentage ? (
                                                <span className="confirm_style">{memberdata.percentage}%</span>
                                            ) : (
                                                <span className="confirm_style">N/A</span>
                                            )}
                                        </td>
                                    </>
                                ) : (
                                    <>
                                        <td className="project-staff-data">
                                            {user
                                                ?.filter((u) => u.id === memberdata.user_id)
                                                .map((u) => (
                                                    <span key={u.id} className="confirm_style">
                                                        {u.name}
                                                    </span>
                                                ))}
                                        </td>

                                        <td className="project-staff-data">
                                            {authRole
                                                ?.filter((r) => parseInt(r.cd) === parseInt(memberdata.role_cd))
                                                .map((r) => (
                                                    <span key={r.cd} className="confirm_style">
                                                        {r.code_value1}
                                                    </span>
                                                ))}
                                        </td>
                                        <td className="project-staff-data">
                                            {memberdata.total_work_minute ? (
                                                (() => {
                                                    const total = parseInt(memberdata.total_work_minute, 10);
                                                    const hours = Math.floor(total / 60);
                                                    const minutes = total % 60;
                                                    return (
                                                        <span className="confirm_style">
                                                            {hours}H {minutes}M
                                                        </span>
                                                    );
                                                })()
                                            ) : (
                                                <span className="confirm_style">N/A</span>
                                            )}
                                        </td>
                                        <td className="project-staff-data">
                                            {memberdata.unit_price ? (
                                                <span className="confirm_style">{memberdata.unit_price} Rs</span>
                                            ) : (
                                                <span className="confirm_style">N/A</span>
                                            )}
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={selectedType === "2" ? 5 : 4} style={{ textAlign: "center", verticalAlign: "middle", height: "50px" }}>
                                <div>No project members found</div>
                            </td>
                        </tr>
                    )}
                </tbody>

                <tfoot>
                    <tr className="project_staff_container">

                        <th>Total</th>
                        {selectedType === "2" ? (
                            (() => {
                                const { hours, minutes } = calculateMonthlyTotal();
                                return `${hours}H ${minutes}M`;
                            })()
                        ) : (
                            <td>
                                {Math.floor(totalMinutes / 60)}H {totalMinutes % 60}M
                            </td>
                        )}
                        <td>{totalUnitPrice} Rs</td>
                        {selectedType === "2" && <td>—</td>}
                    </tr>
                </tfoot>
            </table>


            <ScrollTop />
        </>

    );
};

export default ProjectDetails;
